import React, { Component } from 'react';
import { deviceSupported, browserSupported } from 'utils/browser';
import './BrowserSupport.css';

class BrowserSupport extends Component {
  UNSAFE_componentWillMount() {
    window.addEventListener('resize', () => this.forceUpdate());
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this.forceUpdate());
  }

  render () {
    if (!window.debug && !deviceSupported()) {
      return (
        <div className="not-supported">
          <p>
            Groeistad is geoptimaliseerd voor tablet, laptop, PC en digibord.
            Apparaten met een resolutie lager dan 1024x768 pixels worden niet
            ondersteund.
          </p>
        </div>
      );
    }

    if (!window.debug && !browserSupported()) {
      return (
        <div className="not-supported">
          <p>
            Deze browser wordt niet ondersteund, wij raden aan een moderne
            browser zoals Chrome of Firefox te gebruiken.
          </p>
        </div>
      );
    }

    return null;
  }
}

export default BrowserSupport;



// WEBPACK FOOTER //
// ./src/components/BrowserSupport/BrowserSupport.js